import type { BrandhubPlugin } from "@features/plugins/types";

export type PluginLoader = () => Promise<{ default: BrandhubPlugin }>;

/**
 * All plugin modules that exist in the codebase, keyed by plugin key.
 * Being registered here does NOT activate a plugin — which orgs get which
 * plugins is configured on the backend and delivered on `organization.plugins`.
 * `src/features/plugins/orgPlugins.ts` validates those keys, caches the
 * resolved set, and loads the matching modules.
 */
export const registry = {
  approval_order_variant_item_threshold: () =>
    import("./approval_order_variant_item_threshold"),
  channel_uses_item_approval: () => import("./channel_uses_item_approval"),
  group_gl_code: () => import("./group_gl_code"),
  item_approval_qty_threshold: () => import("./item_approval_qty_threshold"),
  item_commodity_code: () => import("./item_commodity_code"),
  brand_code: () => import("./brand_code"),
  item_stock_status: () => import("./item_stock_status"),
  organization_site_banner: () => import("./organization_site_banner"),
  order_window_fulfillment: () => import("./order_window_fulfillment"),
  order_purpose: () => import("./order_purpose"),
  variant_capped_qty: () => import("./variant_capped_qty"),
} satisfies Record<string, PluginLoader>;
